<div class="relative inline-block group">
  <!-- Hidden file input -->
  <input
    #fileInput
    type="file"
    accept="image/*"
    class="hidden"
    (change)="onFileChange($event)"
  />

  <!-- Avatar circle -->
  <div
    class="w-[100px] h-[100px] rounded-full overflow-hidden cursor-pointer ring-4 ring-offset-4 ring-stone-100 dark:ring-stone-800 dark:ring-offset-stone-950 shadow-xl transition-transform duration-200 group-hover:scale-105"
    role="button"
    tabindex="0"
    (click)="openPicker()"
    (keydown.enter)="openPicker()"
    (keydown.space)="openPicker()"
  >
    @if (displayUrl()) {
    <img
      [src]="displayUrl()!"
      alt="Avatar"
      class="w-full h-full object-cover"
    />
    } @else {
    <div class="w-full h-full bg-primary/10 flex items-center justify-center">
      <span class="text-3xl font-bold text-primary">{{ initials() }}</span>
    </div>
    }
  </div>

  <!-- Camera button -->
  <button
    type="button"
    aria-label="Cambiar foto"
    class="absolute bottom-0 right-0 w-9 h-9 rounded-full flex items-center justify-center bg-primary hover:bg-primary/90 text-white shadow-lg border-2 border-white dark:border-stone-950 transition-colors duration-200"
    (click)="openPicker()"
  >
    <span
      class="material-symbols-outlined"
      style="font-size: 16px; font-variation-settings: 'FILL' 1"
    >
      photo_camera
    </span>
  </button>
</div>

<!-- Remove photo link -->
@if (hasPhoto()) {
<button
  type="button"
  class="mt-2 text-xs font-medium text-slate-400 dark:text-slate-500 hover:text-primary dark:hover:text-primary transition-colors cursor-pointer"
  (click)="removePhoto()"
>
  <span class="material-symbols-outlined !text-[14px] align-middle mr-0.5"
    >close</span
  >
  {{ 'COMMON.REMOVE_PHOTO' | translate }}
</button>
}
